<template>
  <article class="example-page">
    <h1>Tabs</h1>
    <tabs :tab-labels="tabLabels" :slot-names="slotNames">
      <div slot="first">Slot 1</div>
      <div slot="second">Slot 2</div>
      <div slot="third">Slot 3</div>
    </tabs>
  </article>
</template>

<script>
import { tabs } from '@/components/layout';

export default {
  components: { tabs },
  data() {
    return {
      tabLabels: ['First', 'Second', 'Third'],
      slotNames: ['first', 'second', 'third'],
    };
  },
};
</script>

<style lang="scss" scoped>


</style>
